// @flow
import type { FavouritePlace } from 'mz-sdk/api_types'
import client from '../../client'
import getAuthorizedUserId from '../user/getAuthorizedUserId'
import format from '../../utils/format'

// Types
type Request = {
  id: string,
  favoriteSource?: 'user' | 'corporation',
}

// API Endpoinds
export const USER_FAVOURITE_PLACES_ENDPOINT = '/auth/users/{0}/favorites/{1}/'
export const CORP_FAVOURITE_PLACES_ENDPOINT = '/auth/corporate-favorites/{1}/'

/**
 * Returns favourite place by id
 * @param {Object} data Query data
 * @param {string} [data.id] Favourite place ID
 * @return {Promise|Error} A resolved Promise with Favourite Place or Rejected with an Error
 */
export const get = (data: Request): Promise<FavouritePlace> => {
  const userId = getAuthorizedUserId()
  const endpointUrl =
    data.favoriteSource === 'corporation'
      ? CORP_FAVOURITE_PLACES_ENDPOINT
      : USER_FAVOURITE_PLACES_ENDPOINT
  const endpoint = format(endpointUrl, userId, data.id)

  return client.get(endpoint)
}

export default get
